import { Button, Card, Input } from "../primitives";
import { useRef } from "react";
import { useTranslation } from "../../hooks/useTranslation";
import { useState } from "react";

export default function DeleteWorkspace({ onConfirm, onCancel, workspaceName }) {
    const delRef = useRef(null);
    const t = useTranslation();
    const [loading, setLoading] = useState(false);

    async function handleConfirm() {
        setLoading(true);
        if (delRef.current.value.toLowerCase() === 'delete') {
            await onConfirm();
        } else {
            // TODO: Translate this too
            alert('Please type "DELETE" to confirm');
        }
        setLoading(false);
    }

    return (
        <Card className='white'>
            <Card.Header>
                <h2>{t('Delete Workspace')}</h2>
            </Card.Header>
            <Card.Body>
                <p>{`${t('Are you sure you want to delete')} ${workspaceName}`}</p>
                <Input ref={delRef} type='text' placeholder='DELETE' labelText='Type "DELETE" to confirm' />
                <Button onClick={handleConfirm} loading={loading} className='submit'>{t('Delete Workspace')}</Button>
                <Button onClick={onCancel} disabled={loading}>{t('Cancel')}</Button>
            </Card.Body>
        </Card>
    )
}
